import styled from 'styled-components';

export const PageWrapStyles = styled.div`
  position: relative;
  width: calc(100% - 4px);
  padding: 2px;
  max-width: 630px;
  margin: 0 auto;
`;
